module.exports = __webpack_public_path__ + "images/emoji/pear.cec8b5b9575e035b7ac7.png";